import styled from 'styled-components';
import { FLUENT_UI_EMOJIS } from '../../assets';

export const SmallCompanySizeIcon = styled(FLUENT_UI_EMOJIS.SEEDLING)``;

export const MediumCompanySizeIcon = styled(FLUENT_UI_EMOJIS.HERB)``;

export const LargeCompanySizeIcon = styled(FLUENT_UI_EMOJIS.EVERGREEN_TREE)``;

export const VeryLargeCompanySizeIcon = styled(FLUENT_UI_EMOJIS.DECIDUOUS_TREE)``;
